import {Box, Container, styled} from '@mui/material';
import {StyledGrid} from 'presentation/components';

export const CustomStyledGridItem = styled(StyledGrid.Item)`
	${({theme}) => theme.breakpoints.down('md')} {
		&.MuiGrid-item {
			:first-child {
				padding-top: 0;
			}
		}
	}
`;

type StyledFooterContainerProps = {
	$hasDoubleButton?: boolean;
};

export const StyledFooterContainer = styled(Box)<StyledFooterContainerProps>`
	margin: ${props => (props.$hasDoubleButton ? 'auto 0px 124px' : 'auto 0px 72px')};
	padding-top: 40px;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin: auto 0px 0px;
		& footer {
			margin-inline: 24px;
		}
	}

	${({theme}) => theme.breakpoints.up('md')} {
		margin: auto 24px 0px;
		& footer {
			margin-inline: 0px;
		}
	}
`;

export const CustomContainer = styled(Container)`
	${({theme}) => theme.breakpoints.down('md')} {
		padding: 0;
	}
`;
